import loadable from '@loadable/component';

export const ExpiredVolopPageLoadable = loadable(
  () => import('./ExpiredVolopPage'),
  {
    resolveComponent: (module) => module.ExpiredVolopPage,
  },
);
